module.exports = __webpack_public_path__ + "static/media/bg-waterfall-tablet.4e3bbe04.jpg";